import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { map, Observable, take } from 'rxjs';
import { UI_ROUTES } from 'src/app/app.contant';
import { RoleEnum } from '../../shared/models';
import { AuthService } from './auth/auth.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DeGuard implements CanActivate {

  public readonly ROUTES = UI_ROUTES;

  constructor(
    private authService: AuthService,
    private _toastr : ToastrService,
    private localStorageService: LocalStorageService,
    private router: Router) { }
    
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if(this.authService.isAuthenticated()) {
        if(this.localStorageService.getAccessModule() == 'MODULE_ACCESS'){
          return true
        }
        else{
        const roleInfo = this.authService.getUserRole();
        if(roleInfo) {
          this.authService.routeRedirection(roleInfo);
        }
        return false;
      }
      }
      return true

      // return this.authService.isLoggedIn.pipe(
      //   take(1),
      //   map((isLoggedIn: boolean) => {
      //     if (isLoggedIn) {
      //       const roleInfo = this.authService.getUserRole();
      //       if(roleInfo) {
      //          this.authService.routeRedirection(roleInfo);
      //       }
      //       return false;
      //     }
      //     return true;
      //   })
      // );
  }
  
}
